import React from 'react';
import { useHistory } from 'react-router-dom';
import '../dashboard/css/Article1.css';
import blogImage from '../dashboard/assets/Article.avif';
import blog1 from '../dashboard/assets/Articles4.webp';

const Article4 = () => {
  const history = useHistory();

  return (
    <div className="rsh-blog-section">
      {/* Hero */}
      <div
        className="rsh-blog-hero"
        style={{ backgroundImage: `url(${blogImage})` }}
      >
        <div className="rsh-blog-overlay">
          <h1 className="rsh-blog-title">Articles</h1>
          <p className="rsh-breadcrumb">
            <span onClick={() => history.push('/')}>Home</span> / Articles
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="rsh-blog-container">
        <h2 className="rsh-section-title">
          Board Exam Success Stories from Ahmedabad Students
        </h2>

        <div className="rsh-published-badge">
          Published on: 04 January 2026
        </div>

        <img
          src={blog1}
          alt="Board Exam Success Stories from Ahmedabad Students"
          className="rsh-blog-detail-img"
        />

        <div className="rsh-blog-detail-content">
          <p className="intro-text">
            Board examinations are a defining milestone in every student’s
            academic journey. In a competitive city like Ahmedabad, where
            students face high expectations from schools and families,
            personalized home tuition has emerged as a game-changer in achieving
            outstanding board exam results.
          </p>

          <p>
            Over the years, many students from Ahmedabad studying under CBSE,
            ICSE, and Gujarat Board have significantly improved their
            performance with the help of experienced home tutors. These success
            stories highlight how focused guidance, structured preparation, and
            consistent mentoring can transform academic outcomes.
          </p>

          {/* STORY 1 */}
          <div className="info-box">
            <h3>Success Story 1: From Average Scores to Distinction</h3>
            <p>
              A Class 10 CBSE student from Satellite, Ahmedabad, was struggling
              with Mathematics and Science, consistently scoring below average.
              With the support of a dedicated home tutor, the student received
              concept-focused teaching and regular practice sessions.
            </p>
            <p>
              Within six months, the student gained confidence, improved problem
              solving skills, and eventually scored above 90% in the board
              exams.
            </p>
          </div>

          {/* STORY 2 */}
          <div className="info-box">
            <h3>Success Story 2: Gujarat Board Student Overcomes Exam Fear</h3>
            <p>
              A Class 12 Gujarat Board student from Maninagar faced severe exam
              anxiety and difficulty managing the vast syllabus. Personalized
              home tuition helped break the syllabus into manageable sections
              with regular revision tests.
            </p>
            <p>
              The result was a calm exam performance and a significant jump in
              overall percentage, enabling admission into a reputed college in
              Ahmedabad.
            </p>
          </div>

          {/* STORY 3 */}
          <div className="info-box">
            <h3>Success Story 3: ICSE Student Excels in English & Social Studies</h3>
            <p>
              An ICSE student from Navrangpura needed improvement in English
              writing skills and Social Studies answer presentation. A subject
              specialist home tutor focused on structured answers, vocabulary,
              and exam-oriented practice.
            </p>
            <p>
              The student achieved top grades and was among the highest scorers
              in the school.
            </p>
          </div>

          {/* WHY HOME TUITION */}
          <div className="info-box">
            <h3>Why Home Tuition Works for Board Exams in Ahmedabad</h3>
            <ul>
              <li>Personalized attention based on student weaknesses</li>
              <li>Customized study plans aligned with board syllabus</li>
              <li>Regular mock tests and performance tracking</li>
              <li>Reduced stress through one-to-one mentoring</li>
            </ul>
          </div>

          {/* TABLE */}
          <h3 className="table-title">
            Key Benefits of Home Tuition for Board Exam Preparation
          </h3>

          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Aspect</th>
                  <th>Home Tuition</th>
                  <th>Classroom Coaching</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Attention Level</td>
                  <td>100% focused on one student</td>
                  <td>Divided among many students</td>
                </tr>
                <tr>
                  <td>Study Pace</td>
                  <td>Customized</td>
                  <td>Uniform</td>
                </tr>
                <tr>
                  <td>Exam Strategy</td>
                  <td>Personalized</td>
                  <td>Generalized</td>
                </tr>
                <tr>
                  <td>Comfort</td>
                  <td>Home environment</td>
                  <td>Classroom setting</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* FINAL */}
          <div className="info-box">
            <h3>Final Thoughts</h3>
            <p>
              These board exam success stories from Ahmedabad students clearly
              demonstrate the impact of personalized home tuition. With the
              right tutor, consistent effort, and structured guidance, students
              can overcome academic challenges and achieve remarkable results in
              their board examinations.
            </p>
          </div>

          <div className="rsh-back-btn-wrapper">
            <button
              className="rsh-back-btn"
              onClick={() => history.push('/index')}
            >
              Go Back To Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Article4;